import { FormFieldsForm } from "components/Forms/FormFieldsForm/FormFieldsForm.tsx";
import { LocationSectionHeader } from "components/UI/LocationSectionHeader";
import { SectionContentWrapper } from "components/UI/SectionContentWrapper";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums.ts";
import { FormId } from "types/models.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getToolStructureLeadHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/structure/"
)({
    component: LeadStructureStructurePage,
    staticData: {
        permissions: [PermissionEnum.ToolStructureFormStructure],
        showInSideMenu: false,
        label: "pages.tool.structure.lead.structure.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.tool.structure.lead.structure.title"),
        };
    },
});

function LeadStructureStructurePage() {
    const { formStructureId } = Route.useParams();

    return (
        <TenantPage
            headerNavigationItems={getToolStructureLeadHeaderItems}
            isEdit={true}
            saveFormId={FormId.FormFieldsForm}
        >
            <SectionContentWrapper withBackground>
                <LocationSectionHeader level={3} className="mt-3" />
                <FormFieldsForm key={formStructureId} formStructureId={formStructureId} />
            </SectionContentWrapper>
        </TenantPage>
    );
}
